"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BackButton = void 0;
var core_ui_1 = require("@newfront-insurance/core-ui");
var react_1 = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
// eslint-disable-next-line @typescript-eslint/naming-convention
var StyledBackButton = styled_components_1.default.a(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  cursor: pointer;\n  position: relative;\n  align-items: center;\n  display: flex;\n  width: fit-content;\n  &:hover {\n    background: ", ";\n    border-radius: 100px;\n    box-shadow: 0 0 0 10px ", ";\n  }\n"], ["\n  cursor: pointer;\n  position: relative;\n  align-items: center;\n  display: flex;\n  width: fit-content;\n  &:hover {\n    background: ", ";\n    border-radius: 100px;\n    box-shadow: 0 0 0 10px ", ";\n  }\n"])), core_ui_1.colors.steel[100], core_ui_1.colors.steel[100]);
function BackButton(props) {
    var _a = props.tooltipText, tooltipText = _a === void 0 ? 'Back' : _a, onClick = props.onClick;
    var _b = (0, react_1.useState)(false), isOpen = _b[0], setIsOpen = _b[1];
    var targetRef = (0, react_1.useRef)();
    var popoverRef = (0, react_1.useRef)();
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(StyledBackButton, { href: "#", className: "backlink", onClick: onClick, onFocus: function () { return setIsOpen(true); }, onMouseOver: function () { return setIsOpen(true); }, onMouseOut: function () { return setIsOpen(false); }, onBlur: function () { return setIsOpen(false); }, ref: targetRef },
            react_1.default.createElement(core_ui_1.Arrow, null)),
        react_1.default.createElement(core_ui_1.Portal, { name: "tooltip" },
            react_1.default.createElement(core_ui_1.Tether, { targetRef: targetRef, targetAnchor: "right", anchor: "left", xOffset: 20 },
                react_1.default.createElement(core_ui_1.PopoverAnimation, { isOpen: isOpen, direction: "left" },
                    react_1.default.createElement(core_ui_1.Box, { borderRadius: 3, elementRef: popoverRef, backgroundColor: core_ui_1.colors.steel[500] },
                        react_1.default.createElement(core_ui_1.Padding, { size: 8 },
                            react_1.default.createElement(core_ui_1.Text, { color: "white" }, tooltipText))))))));
}
exports.BackButton = BackButton;
var templateObject_1;
